export default __webpack_public_path__ + "static/media/oggi1.4adffc26.jpg";